module.exports = __webpack_public_path__ + "static/media/Artboard16.e51370bb.png";